import { sendGet, sendPost } from 'helpers/axios';

export const apiGetQuestionInterview = (params) => sendGet(`/api/question-interview/get-list`, params);
export const apiGetQuestionInterviewDetail = (params) => sendGet(`/api/question-interview/get-detail`, params);
export const addOrUpdateQuestionInterview = (params) => sendPost('/api/question-interview/save', params);

export const apiGetQuestionsInterview = (applyId) => sendGet(`/api/candidate/apply/${applyId}/get-question-interview`);
export const apiInsertQuestionInterView = (applyId, params) =>
sendPost(`/api/candidate/apply/${applyId}/insert-question-interview`, params);
